import React from 'react';
import { Alert } from 'react-bootstrap';
import BzmIcon from '../icons/BzmIcon';

const MarEolAlert = () => {
  return (
    <Alert variant={'warning'}>
      <BzmIcon variant={'icon-bzm-caution'} className={'alert-icon'} />
      <p className="alert-message mb-0">
        The BlazeMeter Virtual Service Environment (MAR file support) has reached its end of life (EOL) and is no longer
        supported. Please reach out to your account team for any questions.
      </p>
    </Alert>
  );
};

export default MarEolAlert;
